import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from 'react';
import { RefStack } from './utils/RefStack';
import { NestingContext } from './NestingContext';
export var NestingRoot = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NestingRoot, _React$Component);

  function NestingRoot() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.registry = new RefStack();
    _this.parentRef = /*#__PURE__*/React.createRef();

    _this.getRefs = function () {
      return _this.registry.getContextRefs(_this.parentRef);
    };

    return _this;
  }

  var _proto = NestingRoot.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.registry.register(this.parentRef);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.registry.unregister(this.parentRef);
  };

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(NestingContext.Provider, {
      value: this.registry
    }, this.props.children(this.getRefs, this.parentRef));
  };

  return NestingRoot;
}(React.Component);
//# sourceMappingURL=NestingRoot.js.map
